import { render } from "./WorkflowCleaning.vue?vue&type=template&id=54b3f946"
import script from "./WorkflowCleaning.vue?vue&type=script&lang=js"
export * from "./WorkflowCleaning.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__